export enum PlaylistDetailMode {
  Preview,
  Edit,
}
